/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface YearlyBalanceSummary
 */
export interface YearlyBalanceSummary {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof YearlyBalanceSummary
     */
    year: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof YearlyBalanceSummary
     */
    totalCharged: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyBalanceSummary
     */
    totalPaid: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyBalanceSummary
     */
    outstandingBalance: number;
    /**
     * 
     * @type {number}
     * @memberof YearlyBalanceSummary
     */
    totalAccountCredit: number;
}

/**
 * Check if a given object implements the YearlyBalanceSummary interface.
 */
export function instanceOfYearlyBalanceSummary(value: object): value is YearlyBalanceSummary {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('totalCharged' in value) || value['totalCharged'] === undefined) return false;
    if (!('totalPaid' in value) || value['totalPaid'] === undefined) return false;
    if (!('outstandingBalance' in value) || value['outstandingBalance'] === undefined) return false;
    if (!('totalAccountCredit' in value) || value['totalAccountCredit'] === undefined) return false;
    return true;
}

export function YearlyBalanceSummaryFromJSON(json: any): YearlyBalanceSummary {
    return YearlyBalanceSummaryFromJSONTyped(json, false);
}

export function YearlyBalanceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearlyBalanceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'year': ApiUserTasksGetPageParameterFromJSON(json['year']),
        'totalCharged': json['totalCharged'],
        'totalPaid': json['totalPaid'],
        'outstandingBalance': json['outstandingBalance'],
        'totalAccountCredit': json['totalAccountCredit'],
    };
}

export function YearlyBalanceSummaryToJSON(json: any): YearlyBalanceSummary {
    return YearlyBalanceSummaryToJSONTyped(json, false);
}

export function YearlyBalanceSummaryToJSONTyped(value?: YearlyBalanceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': ApiUserTasksGetPageParameterToJSON(value['year']),
        'totalCharged': value['totalCharged'],
        'totalPaid': value['totalPaid'],
        'outstandingBalance': value['outstandingBalance'],
        'totalAccountCredit': value['totalAccountCredit'],
    };
}

